import React from "react";
import { StatamicHtml } from "../../../utils/statamicAssets";

const Panel = ({data, classes}) => {

    const title = data.title;
    const copy = data.copy;

    return(
        <div className={`flexipage-panel ${classes}`}>
            <div className="panel-title">
                <h3>{title}</h3>
            </div>
            {copy && <StatamicHtml className="panel-copy" html={copy} />}
        </div>
    )
}

export default Panel;
